import React, {Component} from 'react';
import {Link, Redirect} from "react-router-dom";
import $ from 'jquery';
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import ContentLoader from'./contentLoader';
import moment from 'moment';

class ProductStoreDetails extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            apiUrl: this.decryptconfigdata('apiUrl'),
            studioUrl: this.decryptconfigdata('studioUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            billing_details: [],
            cards_list: [],
            applications: [],
            account_manager: {},
            content_analytics: [],
            get_billing_api: 0,
            get_content_api: 0,
            get_template_api: 0,
            muvi_one: '3D28C83C85544F0D9517DD2E7C7EEDAA',
            enterprise_api_gateway_url: '',
            get_bandwidth_api : 0,
            bandwidth:'',
            api_gateway_url: 'https://apigateway.muvi.com',
            logger_url: 'https://analytics.muvi.com/data/getbySQL/',
            logger_enterprise_url: 'https://starrrtlogs.muvi.com/data/getbySQL/',
        };
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    getRecentAccount() {
        if (this.state.get_billing_api == 1) {
            return (
                    <div>
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Cancelled By</div>
                                    <div class="bottom-text">{this.state.billing_details.cancellation ? this.state.billing_details.cancellation.canceled_by : 'NA'}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Cancellation Reason</div>
                                    <div class="bottom-text">{this.state.billing_details.cancellation ? this.state.billing_details.cancellation.reason : 'NA'}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">On hold Period</div>
                                    <div class="bottom-text">{this.state.billing_details.cancellation ? new Date(this.state.billing_details.cancellation.onhold_period[0]).toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"}) + " - " + new Date(this.state.billing_details.cancellation.onhold_period[1]).toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"}) : 'NA'}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Cancellation Date</div>
                                    <div class="bottom-text">{this.state.billing_details.cancellation ? new Date(this.state.billing_details.cancellation.date).toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"}) : 'NA'}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Deleted by</div>
                                    <div class="bottom-text">{this.state.billing_details.deletion ? this.state.billing_details.deletion.deleted_by : 'NA'}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Deletion Date</div>
                                    <div class="bottom-text">{this.state.billing_details.deletion ? new Date(this.state.billing_details.deletion.date).toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"}) : 'NA'}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Blocked</div>
                                    <div class="bottom-text">{this.state.billing_details.is_blocked == 1 ? 'Yes' : 'No'}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    )
        } else {
            return (<div></div>)
        }
    }

    getRecentBilling() {
        if (this.state.get_billing_api == 1) {
            return (
                    <div>
                    
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Last Paid Amount</div>
                                    <div class="bottom-text">{this.state.billing_details.last_transaction_amount || this.state.billing_details.last_transaction_amount == 0 ? '$' + this.state.billing_details.last_transaction_amount : 'NA'}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Mode of payment</div>
                                    <div class="bottom-text">{this.state.billing_details.payment_type ? this.state.billing_details.payment_type : 'NA'}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Subscription Started On</div>
                                    <div class="bottom-text">{this.state.billing_details.first_subsription_date ? new Date(this.state.billing_details.first_subsription_date).toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"}) : 'NA'}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Revenue Last 30Days</div>
                                    <div class="bottom-text">{this.state.billing_details.revenue_last_month || this.state.billing_details.revenue_last_month == 0 ? '$' + this.state.billing_details.revenue_last_month : 'NA'}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Revenue Lifetime</div>
                                    <div class="bottom-text">{this.state.billing_details.revenue_lifetime || this.state.billing_details.revenue_lifetime == 0 ? '$' + this.state.billing_details.revenue_lifetime : 'NA'}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Last Transaction Date</div>
                                    <div class="bottom-text">{this.state.billing_details.last_transaction_date ? new Date(this.state.billing_details.last_transaction_date).toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"}) : 'NA'}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Next Subscription Billing Date</div>
                                    <div class="bottom-text">{this.state.billing_details.next_subsription_date ? new Date(this.state.billing_details.next_subsription_date).toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"}) : 'NA'}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Next Infra Billing Date</div>
                                    <div class="bottom-text">{this.state.billing_details.next_infra_billing_date ? new Date(this.state.billing_details.next_infra_billing_date).toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"}) : 'NA'}</div>
                                </div>
                            </div>
                            {this.getRecentCards()}
                        </div>
                    </div>)
        } else {
            return (<div></div>)
        }
    }

    getRecentProduct() {
        if (this.state.get_billing_api == 1) {
            return (<div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="single-box">
                <div class="only-text">
                        <div class="top-text">Customer Type</div>
                        <div class="bottom-text cap-text">{this.state.billing_details.account_status ? this.state.billing_details.account_status : "NA"}</div>
                    </div>
                </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="single-box">
                <div class="only-text">
                        <div class="top-text">Product</div>
                        <div class="bottom-text">{this.props.products.product_name ? this.props.products.product_name : "NA"}</div>
                    </div>
                </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="single-box">
                <div class="only-text">
                        <div class="top-text">Joined On</div>
                        <div class="bottom-text">{this.state.billing_details.created_date ? new Date(this.state.billing_details.created_date).toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"}) : 'NA'}</div>
                    </div>
                </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="single-box">
                <div class="only-text">
                        <div class="top-text">Product Plan</div>
                        <div class="bottom-text cap-text">{this.state.billing_details.subscribed_plans ? this.state.billing_details.subscribed_plans.platform.name : "NA"}</div>
                    </div>
                </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="single-box">
                <div class="only-text">
                        <div class="top-text">Product Pricing</div>
                        <div class="bottom-text">{this.state.billing_details.subscribed_plans ? '$' + this.state.billing_details.subscribed_plans.platform.base_price : "NA"}</div>
                    </div>
                </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="single-box">
                <div class="only-text">
                        <div class="top-text">Plan Term</div>
                        <div class="bottom-text">{this.state.billing_details.subscribed_plans ? this.state.billing_details.subscribed_plans.platform.interval : 'NA'}</div>
                    </div>
                </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="single-box">
                <div class="only-text">
                        <div class="top-text">Source</div>
                        <div class="bottom-text">{this.props.source && this.props.source != 'NA' ? <Link to={`${this.props.source}`} name={"max"} target="_blank"> {this.props.source} </Link> : "NA"}</div>
                    </div>
                </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="single-box">
                <div class="only-text">
                        <div class="top-text">Applications</div>
                        <div class="bottom-text">
                            {this.state.applications.length > 0 ? this.state.applications.map((data, key) =>
                                <span> {data.name}{key !== this.state.applications.length - 1 ? ', ' : ''}</span>
                            ) : 'NA'}
                        </div>
                    </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="single-box">
                <div class="only-text">
                        <div class="top-text">Free Trial Expires On</div>
                        <div class="bottom-text">{this.state.billing_details.free_trial_expiry_date ? new Date(this.state.billing_details.free_trial_expiry_date).toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"}) : 'NA'}</div>
                    </div>
                </div>
                </div>
                {this.getTemplate()}
            </div>
                    )
        } else {
            return (<div></div>)
        }
    }

    getBillingDetails() {
         if(this.props.products.is_enterprise){
        this.setState({
            api_gateway_url: this.props.products.enterprise_api_gateway_url
        })    
        var enterprise_api_gateway_url =  this.props.products.enterprise_api_gateway_url;
        }else{
        this.setState({
            api_gateway_url: 'https://apigateway.muvi.com'
        })
        var enterprise_api_gateway_url =  this.state.enterprise_api_gateway_url;  
        }
        var productKey = this.props.product_key;
        var appToken = this.props.app_token;
        var storeKey = this.props.store_key;

        let columnsfetch = {
            "app_token": appToken,
            "product_key": productKey,
            "store_key": storeKey,
            "enterprise_api_gateway_url": enterprise_api_gateway_url
        };
        fetch(this.state.apiUrl + '/crmRest/getBillingDetails/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(columnsfetch),
        }).then((Response) => Response.json())
                .then((findresponse) => {
                    if (findresponse.code == 200) {
                        this.setState({
                            billing_details: findresponse.data,
                            applications: findresponse.data.subscribed_plans ? findresponse.data.subscribed_plans.applications : '',
                            account_manager: findresponse.account_manager_data ? findresponse.account_manager_data : '',
                            get_billing_api: 1
                        })
                    }
                })
                .then(() => {
                    this.getCardDetails();
                })
                .then(() => {
                    this.getContentDetails();
                })
                .then(() => {
                    this.getBandwidthDetails();
                })
                .then(() => {
                    this.getTemplateDetails();
                })
    }

    getRecentCards() {
        if (this.state.cards_list.length > 0) {
            return (
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="single-product">
                                    <div class="top-text">Card Details</div>
                                    <div class="bottom-text">
                                    {this.state.cards_list.map((data, key) =>
                                <span> {data.masked_card.slice(-4)}{key !== this.state.cards_list.length - 1 ? ', ' : ''}</span>
                            )}
                            </div>
                                </div>
                            </div>
                            )
        } else {
            return (<div></div>)
        }
    }

    getCardDetails() {
        fetch(this.state.api_gateway_url+'/cards', {
            method: 'POST',
            dataType: 'json',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: `{cards ( app_token:"${this.props.app_token}", product_key:"${this.props.product_key}", user_uuid:"${this.props.user_uuid}", store_key:"${this.props.store_key}" ) { page_info { total_count } cards_list { card_uuid name brand masked_card is_primary last4 created_date last_transaction_date } }}`
            })
        }).then((Response) => Response.json())
                .then((findresponse) => {
                    if (findresponse.code == 200) {
                        this.setState({
                            cards_list: findresponse.data.cards.cards_list,
                        })
                    }
                })
    }

    getRecentBandwidth(){
        return  (<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div class="single-box">
                                <div class="icon-box">
                                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <mask id="mask0_148_2961" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="14">
                                        <path d="M8.03 0.999994C4.14733 0.999994 1 4.14733 1 8.02999C1 9.86834 1.60212 11.6982 2.7575 12.951H13.3025C14.4575 11.6982 15.06 9.86834 15.06 8.02999C15.06 4.14733 11.9127 0.999994 8.03 0.999994Z" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M8.03002 10.4905C8.80654 10.4905 9.43602 9.86101 9.43602 9.0845C9.43602 8.30799 8.80654 7.6785 8.03002 7.6785C7.25351 7.6785 6.62402 8.30799 6.62402 9.0845C6.62402 9.86101 7.25351 10.4905 8.03002 10.4905Z" fill="white" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M8.02982 5.5695V7.6785M8.02982 2.7575V3.4605M2.75732 8.3815H3.46032M4.16332 4.8665L4.66035 5.36352M12.5993 8.3815H13.3023M11.5448 5.36352L12.0418 4.8665" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </mask>
                                    <g mask="url(#mask0_148_2961)">
                                    <path d="M-0.679688 -1.46051H16.5438V15.4115H-0.679688V-1.46051Z" fill="#52B7ED"></path>
                                    </g>
                                    </svg>
                                </div>
                                <div class="only-text">
                                    <div class="top-text">Bandwidth Used This Month</div>
                                    <div class="bottom-text">{this.state.get_bandwidth_api == 1 ? this.state.bandwidth : 'NA'}</div>
                                </div>
                            </div>
                            </div>
                                        )  
    }
    
    formatBytes(bytes) {
        if (!+bytes) return '0.00 B';
        var size = 'GB';
        return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} ${size}`
    }
    
    getTemplateDetails() {
        if (this.props.product_key == this.state.muvi_one) {
            let columnsfetch = {
                "app_token": this.props.app_token
            };

            fetch(this.state.api_gateway_url + '/frontend/get-account-template', {
                method: 'POST',
                dataType: 'json',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(columnsfetch)
            }).then((Response) => Response.json())
                    .then((findresponse) => {
                        if (findresponse.code == 200) {
                            this.setState({
                                template: findresponse.data.template_name,
                                get_template_api: 1
                            })
                        }
                    })
        } else {
            this.setState({
                get_template_api: 0
            })
        }
    }
    
    getBandwidthDetails(){
    var productKey = this.props.product_key;
    var appToken = this.props.app_token;
    const firstdate = moment().startOf('month').format('YYYY-MM-DD');
    if(appToken == 'rvtCeZWThBs3FidLmkWlPA3SI2NjXdkU' & productKey == '3D28C83C85544F0D9517DD2E7C7EEDAA'){
    var bandwidth = this.state.logger_enterprise_url;  
    var bandwidth_query = `select sum(buffer_size) as total_bandwidth from muvi6_vod_log_prod where created_date >= '`+firstdate+`'`;
    }else{
    var bandwidth = this.state.logger_url;  
    var bandwidth_query = `select sum(total_buffer_size) as total_bandwidth from muvi_totalbandwidth_live where app_token = '`+appToken+`' and product_key = '`+productKey+`' and created_date >= '`+firstdate+`'`;
    }
    fetch(bandwidth, {
            method: 'POST',
            dataType: 'json',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: bandwidth_query
            })
        }).then((Response) => Response.json())
                .then((findresponse) => {
                   if (findresponse.code == 200) {
                       var total_bandwidth = this.formatBytes(findresponse.result[0].total_bandwidth);
                            this.setState({
                                bandwidth: total_bandwidth,
                                get_bandwidth_api:1
                            })
                        }
                })
    }

    getRecentContent() {
        if (this.state.get_content_api == 1) {
            return  (<div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <div class="single-box">
                    <div class="icon-box">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_148_2952)">
                        <path d="M14.1399 10.5933C13.7158 11.5963 13.0525 12.4801 12.2079 13.1675C11.3633 13.8549 10.3631 14.3249 9.2949 14.5365C8.22668 14.7481 7.12289 14.6948 6.08004 14.3812C5.03719 14.0676 4.08703 13.5034 3.31262 12.7378C2.53822 11.9722 1.96315 11.0285 1.6377 9.9893C1.31225 8.9501 1.24632 7.84699 1.44568 6.77642C1.64503 5.70585 2.10361 4.70042 2.78131 3.84802C3.45901 2.99562 4.3352 2.32221 5.33328 1.88667" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M14.6667 8C14.6667 7.12452 14.4942 6.25762 14.1592 5.44878C13.8242 4.63994 13.3331 3.90501 12.714 3.28596C12.095 2.6669 11.3601 2.17584 10.5512 1.84081C9.74239 1.50577 8.87548 1.33334 8 1.33334V8H14.6667Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                        </g>
                        <defs>
                        <clipPath id="clip0_148_2952">
                            <rect width="16" height="16" fill="white"></rect>
                        </clipPath>
                        </defs>
                        </svg>
                    </div>
                    <div class="only-text">
                        <div class="top-text">Storage</div>
                        <div class="bottom-text">{this.state.content_analytics.total_storage_consumption}</div>
                    </div>
                </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="single-box">
                    <div class="icon-box">
                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_148_2996)">
                        <path d="M7.99231 14.5428C8.08462 15.0846 8.27692 15.5887 8.54615 16.0476H2.53846C1.68462 16.0476 1 15.378 1 14.5428V2.50475C1 2.10566 1.16209 1.72292 1.4506 1.44072C1.73912 1.15852 2.13044 0.999985 2.53846 0.999985H8.69231L13.3077 5.51427V9.34389C13.0538 9.30627 12.8 9.27618 12.5385 9.27618C12.2769 9.27618 12.0231 9.30627 11.7692 9.34389V6.26665H7.92308V2.50475H2.53846V14.5428H7.99231ZM11 10.7809L9.07692 13.0381H10.2308V16.0476H11.7692V13.0381H12.9231L11 10.7809ZM14.8462 14.5428V11.5333H13.3077V14.5428H12.1538L14.0769 16.8L16 14.5428H14.8462Z" fill="#52B7ED"></path>
                        </g>
                        <defs>
                        <clipPath id="clip0_148_2996">
                            <rect width="16" height="16" fill="white" transform="translate(0 0.673462)"></rect>
                        </clipPath>
                        </defs>
                        </svg>
                    </div>
                    <div class="only-text">
                        <div class="top-text">Total Content Uploaded</div>
                        <div class="bottom-text">{this.state.content_analytics.total_content}</div>
                    </div>
                </div> 
                </div> 
            </div>
                    )
        } else {
            return (<div></div>)
        }
    }

    getContentDetails() {
        fetch(this.state.api_gateway_url+'/content/content-analytics', {
            method: 'POST',
            dataType: 'json',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: `{contentAnalytics(app_token:"${this.props.app_token}", product_key:"${this.props.product_key}", store_key:"${this.props.store_key}"){total_content,total_storage_consumption}}`
            })
        }).then((Response) => Response.json())
                .then((findresponse) => {
                    if (findresponse.code == 200) {
                        this.setState({
                            content_analytics: findresponse.data.contentAnalytics,
                            get_content_api: 1
                        })
                    }
                })
    }

    componentDidMount()
    {
        document.title = "Intranet | Customer Details";
        if (!localStorage.getItem('userLogin')) {
            this.setState({redirect: true});
        }
        console.log('props', this.props);
//this.getCardDetails();
        this.getBillingDetails();
//this.getContentDetails();
    }

    componentDidUpdate(prevProps) {
        // Check if the data prop has changed
        if (this.props.product_key !== prevProps.product_key) {
            // Data has changed, call your API
            this.getBillingDetails();
        }
        if (this.props.account_manager !== this.state.account_manager) {
        this.props.getAccountManager(this.state.account_manager);    
    }
    }

    getTemplate() {
            return  (<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="single-box">
                <div class="only-text">
                        <div class="top-text">Template</div>
                        <div class="bottom-text">{this.state.get_template_api ? this.state.template : 'NA'}</div>
                    </div>
                </div>
                </div>
                    )
    } 
    
    getRevenue() {
        if (this.state.billing_details.revenue_from_user.length > 0) {
            return(
                    <select class="form-control customer_form-control">
                        {this.state.billing_details.revenue_from_user.map((currency, key) =>
                                                <option value="">{currency.currency_symbol} {currency.amount.toFixed(2)}</option>
                                )}
                    </select>
                    )
        }
    } 

    render() {
        if (this.state.redirect) {
            return (
                    <Redirect to={'/login'} />
                    )
        }
        return (
                <div>
                <div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 separators padding-right">
                            <div class="store-title">Product</div>
                            {this.getRecentProduct()}  
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 padding-left">
                            <div class="store-title">Analytics</div>
                            <div class="row">
                            {this.getRecentContent()}
                            {this.getRecentBandwidth()}
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div class="single-box">
                                <div class="icon-box">
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 2.67347H12.6667C13.0203 2.67347 13.3594 2.81395 13.6095 3.06399C13.8595 3.31404 14 3.65318 14 4.0068V13.3401C14 13.6938 13.8595 14.0329 13.6095 14.2829C13.3594 14.533 13.0203 14.6735 12.6667 14.6735H10" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M6.6665 12.0068L9.99984 8.67347L6.6665 5.34014" stroke="#52B7ED" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M10 8.67347H2" stroke="#52B7ED" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                                <div class="only-text">
                                    <div class="top-text">Count of Login</div>
                                    <div class="bottom-text">{this.props.number_of_login ? this.props.number_of_login : 'NA'}</div>
                                </div>
                            </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div class="single-box">
                                <div class="icon-box">
                                    <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.7189 11.4992V10.4055C12.7189 9.82544 12.4885 9.26909 12.0783 8.85889C11.6681 8.44869 11.1117 8.21825 10.5316 8.21825H6.15702C5.57692 8.21825 5.02057 8.44869 4.61037 8.85889C4.20017 9.26909 3.96973 9.82544 3.96973 10.4055V11.4992" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M8.34452 6.03095C9.55253 6.03095 10.5318 5.05166 10.5318 3.84365C10.5318 2.63564 9.55253 1.65636 8.34452 1.65636C7.13651 1.65636 6.15723 2.63564 6.15723 3.84365C6.15723 5.05166 7.13651 6.03095 8.34452 6.03095Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M15.9998 11.4992V10.4055C15.9995 9.92091 15.8382 9.45012 15.5413 9.06709C15.2443 8.68407 14.8286 8.4105 14.3594 8.28934" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M2.2707 8.26145L1.49697 9.03437C1.15435 9.37713 0.93528 9.82398 0.874142 10.3047C0.813003 10.7855 0.913263 11.273 1.15918 11.6906" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M12.1724 1.72745C12.6429 1.84791 13.0599 2.12154 13.3577 2.5052C13.6555 2.88886 13.8171 3.36072 13.8171 3.84639C13.8171 4.33206 13.6555 4.80392 13.3577 5.18758C13.0599 5.57124 12.6429 5.84487 12.1724 5.96534" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M4.0957 5.97628C3.63047 5.83687 3.22487 5.54658 2.94284 5.15118C2.66081 4.75578 2.51841 4.27777 2.53807 3.79249C2.55773 3.30722 2.73834 2.84229 3.05143 2.471C3.36451 2.09971 3.79227 1.84319 4.26726 1.74187" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                                <div class="only-text">
                                    <div class="top-text">Number of EndUsers</div>
                                    <div class="bottom-text">{this.props.products.total_no_of_users ? this.props.products.total_no_of_users : 'NA'}</div>
                                </div>
                            </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div class="single-box">
                                <div class="icon-box">
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.3332 14.6735V13.3401C11.3332 12.6329 11.0522 11.9546 10.5521 11.4545C10.052 10.9544 9.37375 10.6735 8.6665 10.6735H3.33317C2.62593 10.6735 1.94765 10.9544 1.44755 11.4545C0.947456 11.9546 0.666504 12.6329 0.666504 13.3401V14.6735" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M6.00016 8.00679C7.47292 8.00679 8.66683 6.81289 8.66683 5.34013C8.66683 3.86737 7.47292 2.67346 6.00016 2.67346C4.5274 2.67346 3.3335 3.86737 3.3335 5.34013C3.3335 6.81289 4.5274 8.00679 6.00016 8.00679Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M15.3335 14.6735V13.3401C15.3331 12.7493 15.1364 12.1753 14.7744 11.7083C14.4124 11.2414 13.9056 10.9078 13.3335 10.7601" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M10.6665 2.76013C11.2401 2.907 11.7485 3.2406 12.1116 3.70834C12.4747 4.17608 12.6717 4.75135 12.6717 5.34347C12.6717 5.93558 12.4747 6.51085 12.1116 6.97859C11.7485 7.44633 11.2401 7.77993 10.6665 7.9268" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                                <div class="only-text">
                                    <div class="top-text">Number of Subscribers</div>
                                    <div class="bottom-text">{this.props.products.total_no_of_subscribed_users ? this.props.products.total_no_of_subscribed_users : 'NA'}</div>
                                </div>
                            </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div class="single-box">
                                <div class="icon-box">
                                    <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.7189 11.4992V10.4055C12.7189 9.82544 12.4885 9.26909 12.0783 8.85889C11.6681 8.44869 11.1117 8.21825 10.5316 8.21825H6.15702C5.57692 8.21825 5.02057 8.44869 4.61037 8.85889C4.20017 9.26909 3.96973 9.82544 3.96973 10.4055V11.4992" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M8.34452 6.03095C9.55253 6.03095 10.5318 5.05166 10.5318 3.84365C10.5318 2.63564 9.55253 1.65636 8.34452 1.65636C7.13651 1.65636 6.15723 2.63564 6.15723 3.84365C6.15723 5.05166 7.13651 6.03095 8.34452 6.03095Z" fill="#52B7ED" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M15.9998 11.4992V10.4055C15.9995 9.92091 15.8382 9.45012 15.5413 9.06709C15.2443 8.68407 14.8286 8.4105 14.3594 8.28934" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M2.2707 8.26145L1.49697 9.03437C1.15435 9.37713 0.93528 9.82398 0.874142 10.3047C0.813003 10.7855 0.913263 11.273 1.15918 11.6906" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M12.1724 1.72745C12.6429 1.84791 13.0599 2.12154 13.3577 2.5052C13.6555 2.88886 13.8171 3.36072 13.8171 3.84639C13.8171 4.33206 13.6555 4.80392 13.3577 5.18758C13.0599 5.57124 12.6429 5.84487 12.1724 5.96534" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path d="M4.0957 5.97628C3.63047 5.83687 3.22487 5.54658 2.94284 5.15118C2.66081 4.75578 2.51841 4.27777 2.53807 3.79249C2.55773 3.30722 2.73834 2.84229 3.05143 2.471C3.36451 2.09971 3.79227 1.84319 4.26726 1.74187" stroke="#52B7ED" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                                <div class="only-text">
                                    <div class="top-text">Number of SubAdmin</div>
                                    <div class="bottom-text">{this.props.products.subadmin_count || this.props.products.subadmin_count == 0 ? this.props.products.subadmin_count : 'NA'}</div>
                                </div>
                            </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div class="single-box">
                                <div class="icon-box">
                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.3735 14.0809H14.8302V3.21667C14.8302 3.0726 14.773 2.93444 14.6711 2.83256C14.5693 2.73069 14.4311 2.67346 14.287 2.67346H10.4846C10.3405 2.67346 10.2023 2.73069 10.1005 2.83256C9.99859 2.93444 9.94136 3.0726 9.94136 3.21667V5.93272H6.6821C6.53803 5.93272 6.39986 5.98995 6.29799 6.09182C6.19612 6.1937 6.13889 6.33186 6.13889 6.47593V9.19198H2.87963C2.73556 9.19198 2.59739 9.24921 2.49552 9.35108C2.39365 9.45295 2.33642 9.59112 2.33642 9.73519V14.0809H1.79321C1.64914 14.0809 1.51097 14.1381 1.4091 14.24C1.30723 14.3418 1.25 14.48 1.25 14.6241C1.25 14.7681 1.30723 14.9063 1.4091 15.0082C1.51097 15.1101 1.64914 15.1673 1.79321 15.1673H15.3735C15.5175 15.1673 15.6557 15.1101 15.7576 15.0082C15.8594 14.9063 15.9167 14.7681 15.9167 14.6241C15.9167 14.48 15.8594 14.3418 15.7576 14.24C15.6557 14.1381 15.5175 14.0809 15.3735 14.0809ZM7.22531 7.01914H9.94136V14.0809H7.22531V7.01914ZM3.42284 10.2784H6.13889V14.0809H3.42284V10.2784Z" fill="#52B7ED"></path>
                                    </svg>
                                </div>
                                <div class="only-text">
                                    <div class="top-text">Customer Revenue</div>
                                    <div class="bottom-text">{this.state.billing_details.revenue_from_user ? this.getRevenue() : 0}</div>
                                </div>
                            </div>
                            </div>
                    </div>
                    </div>
                    </div>
                    <div class="bottom-area">
                    <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 separator padding-right separators">
                        <div class="product-area revenue-area">
                            <div class="store-title">Revenue &amp; Billing</div>
                            {this.getRecentBilling()}
                        </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 separator padding-right">
                        <div class="product-area account-area">
                            <div class="store-title">Account</div>
                            {this.getRecentAccount()}
                        </div>
                        </div>
                    </div>
                    </div>
                    </div>
                );
    }
}

export default ProductStoreDetails;


// WEBPACK FOOTER //
// ./src/components/customer/ProductStoreDetails.js